var _path, _rect, _rect2, _g, _ellipse, _ellipse2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoBetHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.298,
    height: 58.184,
    viewBox: "0 0 61.298 58.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16371",
    "data-name": "Path 16371",
    d: "M13.5,43.108V24h6.87a17.3,17.3,0,0,1,2.791.215,5.208,5.208,0,0,1,2.254.859,5.092,5.092,0,0,1,1.5,1.825,6.486,6.486,0,0,1,.537,2.576,5.969,5.969,0,0,1-1.5,4.079c-.966,1.074-2.791,1.718-5.368,1.718H15.969V43H13.5Zm2.362-9.984h4.723a5.382,5.382,0,0,0,3.328-.859,3.482,3.482,0,0,0,.966-2.576,4.111,4.111,0,0,0-.537-2.04,2.485,2.485,0,0,0-1.5-1.074,9.77,9.77,0,0,0-2.254-.215H15.969v6.763Z",
    transform: "translate(-11.246 -13.802)",
    fill: "#e00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4446",
    "data-name": "Rectangle 4446",
    width: 18.142,
    height: 1.718,
    transform: "translate(0 13.956)",
    fill: "#e00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4447",
    "data-name": "Rectangle 4447",
    width: 18.142,
    height: 1.718,
    transform: "translate(0 16.639)",
    fill: "#e00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7742",
    "data-name": "Group 7742",
    transform: "translate(10.517 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7741",
    "data-name": "Group 7741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16372",
    "data-name": "Path 16372",
    d: "M42.885,72.684a29.092,29.092,0,1,0,0-58.184H41.6a1.638,1.638,0,0,0-1.61,1.825,1.638,1.638,0,0,0,1.825,1.61h1.181A25.657,25.657,0,1,1,24.1,60.983a1.672,1.672,0,0,0-2.469,2.254A28.628,28.628,0,0,0,42.885,72.684Z",
    transform: "translate(-21.197 -14.5)",
    fill: "#303337"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 1.825,
    cy: 1.825,
    rx: 1.825,
    ry: 1.825,
    transform: "translate(16.639 3.435)",
    fill: "#303337"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 1.825,
    cy: 1.825,
    rx: 1.825,
    ry: 1.825,
    transform: "translate(3.757 34.567)",
    fill: "#303337"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16373",
    "data-name": "Path 16373",
    d: "M49.216,54.406,41.379,42.06l2.04-9.017a1.592,1.592,0,0,0-1.288-1.932L41.594,31a1.592,1.592,0,0,0-1.932,1.288L37.3,42.919h0L46,56.66a2.015,2.015,0,0,0,2.684.644A2.23,2.23,0,0,0,49.216,54.406Z",
    transform: "translate(-9.496 -13.29)",
    fill: "#e00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBetHistory);
export default __webpack_public_path__ + "static/media/no_bet_history.70a34cc94ea518e7a291d5c8a8a19398.svg";
export { ForwardRef as ReactComponent };